import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppPage } from './app.page';

const routes: Routes = [
	{
		path: '',
		component: AppPage,
		children: [
			{
				path: 'jobfair',
				loadChildren: () =>
					import('./jobfair/jobfair.module').then(m => m.JobfairPageModule),
			},
			{
				path: 'courses',
				loadChildren: () =>
					import('./courses/courses.module').then(m => m.CoursesPageModule),
			},
			{
				path: 'people',
				loadChildren: () =>
					import('./people/people.module').then(m => m.PeoplePageModule),
			},
			{
				path: 'company',
				loadChildren: () =>
					import('./company/company.module').then(m => m.CompanyPageModule),
			},
			{
				path: 'serverless',
				loadChildren: () =>
					import('./serverless/serverless.module').then(
						m => m.ServerlessPageModule,
					),
			},
			{
				path: 'epp-signups',
				loadChildren: () =>
					import('./company/epp-signups/epp-signups.module').then(
						m => m.EppSignupsPageModule,
					),
			},
			{
				path: 'profile',
				loadChildren: () =>
					import('./profile/profile.module').then(m => m.ProfilePageModule),
			},
			{
				path: 'hubble',
				loadChildren: () =>
					import('./hubble/hubble.module').then(m => m.HubblePageModule),
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class AppPageRoutingModule {}
